module.exports = __webpack_public_path__ + "src/assets/img/start-white.64694931.svg";